'use client';
import { jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { Link } from '../Link/Link.js';
import { ListItemBaseLi, ListItemBaseInnerWrapper } from './ListItemBase.js';

const StyledLink = styled(Link).withConfig({
  componentId: "sc-yarq6g-0"
})(["&&{width:100%;display:inherit;flex-direction:inherit;text-align:left;", ";", ";}"], ({
  py
}) => py && css(["", " ", ""], spaceProp(py, 'padding-top'), spaceProp(py, 'padding-bottom')), ({
  px
}) => px && css(["", " ", ""], spaceProp(px, 'padding-left'), spaceProp(px, 'padding-right')));
const ListLinkItem = /*#__PURE__*/withTitan(({
  onClick,
  children,
  className,
  linkTo,
  isDisabled,
  px,
  py,
  prefixAdornment,
  suffixAdornment,
  testId = 'listLinkItem'
}) => jsx(ListItemBaseLi, {
  "data-test-id": testId,
  children: jsx(StyledLink, Object.assign({}, linkTo ? {
    to: linkTo
  } : {}, {
    className: className,
    disabled: isDisabled,
    px: px,
    py: py,
    testId: `${testId || ''}${linkTo ? 'Link' : 'Button'}`,
    onClick: onClick,
    children: jsx(ListItemBaseInnerWrapper, {
      prefixAdornment: prefixAdornment,
      suffixAdornment: suffixAdornment,
      children: children
    })
  }))
}), {
  name: 'ListLinkItem'
});

export { ListLinkItem };
//# sourceMappingURL=ListLinkItem.js.map
